import { Button } from "antd"
import { useState } from "react"
import { useEffect } from "react"
import { useParams } from "react-router-dom"
import { baseAxiosNoInfo } from "../../../tool/axios"

interface dataType {
    create_time: string//创建时间
    id: string//跟进记录主键id
    follow_man_name: string//  跟进人
    follow_time: string//  跟进时间
    follow_level_name: string//  跟进等级名称
    follow_way_name: string//  跟进方式名称
    follow_content: string//  跟进内容
    is_effective_customer: string//  是否有效客资
    no_effective_reason_desc: string// 无效原因
    is_effective_clue: string//  是否有效线索
    is_invite_visit: string//  是否邀约进店
    visit_date: string//  邀约进店日期
    visit_store_name: string//  邀约进店门店
    next_follow_limit_date: string//  下次跟进截止日期
    distributed_sales_name: string//  分配销售
    remark: string//  备注
}

export default function () {

    const param: { id: string } = useParams()
    const [page, setPage] = useState<number>(1)
    const [data, setData] = useState<any[]>([])
    const [showLoadBtn, setShowLoadBtn] = useState<boolean>(true)

    useEffect(() => {
        baseAxiosNoInfo('/nursing/customer/detail/item_nursing_records', {
            params: { page,check_in_id: param.id }
        }).then((res: any) => {
            if(res && res.records.length>0){
                let d = data
                setData([...d,...res.records])
            }else{
                setShowLoadBtn(false)
            }
        })
    }, [page])

    return <div className="follow-record">
        {data.length===0 && '暂无数据'}
        {data.map((el:any)=><ul style={{listStyle:'none'}}>
            <li>
                <p className="date">护理时间：{el.nursing_time}</p>
            </li>
            <li>
                <p>护理记录：{el.nursing_records}</p>
            </li>
            <li>
                <p>宝宝体重：{el.baby_weight} </p>
            </li>
            <li>
                <p>护士：{el.nurse_name} </p>
            </li>
            <li>
                <p>项目护理：{el.nursing_care_item_desc}</p>
            </li>
        </ul>)}
        {showLoadBtn  &&  <Button onClick={()=>{
            setPage(page+1)
        }}>加载更多数据</Button>}
       
    </div>
}